import React from 'react'
import { queryStringEncode } from '../util/Serializers'
import { Icon } from 'semantic-ui-react'

export class FacebookButton extends React.Component {
  componentDidMount() {
    ;(function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v3.2'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }

  render() {
    const source = 'https://esmer-games.github.io' + this.props.slug
    const href = queryStringEncode({ u: source }) + '&amp;src=sdkpreparse'
    return (
      <>
        <div id="fb-root" />
        <div
          className="fb-share-button"
          data-href={source}
          data-layout="button_count"
          data-size="small"
          data-mobile-iframe="true"
        >
          <a
            target="_blank"
            href={`https://www.facebook.com/sharer/sharer.php?${href}`}
            className="fb-xfbml-parse-ignore"
            rel="noopener noreferrer"
          >
            <Icon name="facebook f" /> Share
          </a>
        </div>
      </>
    )
  }
}
